const trigger = document.querySelector('[data-offers-open]');
const dialog = document.getElementById('partner-offers');

if (trigger && dialog && typeof dialog.showModal === 'function') {
  trigger.hidden = false;
  trigger.addEventListener('click', () => {
    if (dialog.open) return;
    dialog.showModal();
    document.documentElement.classList.add('offers-open');
    trigger.setAttribute('aria-expanded', 'true');
  });
  dialog.querySelectorAll('[data-offers-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button:not([disabled]), a[href]')];
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) {
      dialog.close();
    }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('offers-open');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus({ preventScroll: true });
  });
}
